/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { WorkSubtypeBase } from "../../../../schema/generated/WorkSubtype";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class WorkSubtypeDataApi extends EntityDataApi<WorkSubtypeBase> {
  public readonly def = idbEntityDefs.WorkSubtype;
}